import Footer from "../footer/Footer";
import Header from "../header/Header";
import BannerHome from "../banner/BannerHome";
import Plans from "./plans/Plans";
import "./HomePage.scss";
import Cids from "./cids/Cids";
import Impact from "./impact/Impact";
import Billion from "./billion/Billion";
import Navigate from "../footer/Navigate";
import ResiliencePlan from "./resilienceplan/ResiliencePlan";
import Testimonials from "./testimonials/Testimonials";

const MainPage = () => {
  return (
    <>
      <Header />
      <BannerHome />
      <ResiliencePlan />
      <Testimonials />
      <Plans />
      <Cids />
      <Billion />
      <Impact />
      <Navigate page="Pathway to Resilience" pagelink="/Resilience" />
      <Footer />
    </>
  );
};

export default MainPage;
